<h2 mat-dialog-title>Editar Vehículo</h2>
<mat-dialog-content>
  <form [formGroup]="editForm">
    <mat-form-field appearance="fill" class="full-width">
      <mat-label>Tipo de Vehículo</mat-label>
      <input matInput formControlName="typevehicle" />
    </mat-form-field>

    <mat-form-field appearance="fill" class="full-width">
      <mat-label>Marca</mat-label>
      <input matInput formControlName="marca" />
    </mat-form-field>

    <mat-form-field appearance="fill" class="full-width">
      <mat-label>Modelo</mat-label>
      <input matInput formControlName="modelo" />
    </mat-form-field>

    <mat-form-field appearance="fill" class="full-width">
      <mat-label>Kilometraje</mat-label>
      <input matInput type="number" formControlName="km" />
    </mat-form-field>

    <mat-form-field appearance="fill" class="full-width">
      <mat-label>Placa</mat-label>
      <input matInput formControlName="plate" />
    </mat-form-field>

    <mat-form-field appearance="fill" class="full-width">
      <mat-label>Color</mat-label>
      <input matInput formControlName="color" />
    </mat-form-field>
  </form>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button (click)="onNoClick()">Cancelar</button>
  <button mat-button color="primary" (click)="onSubmit()" [disabled]="!editForm.valid">Guardar</button>
</mat-dialog-actions>
